import React from "react";

import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import InformationCircleIcon from "@atlaskit/icon/core/information-circle";
import { token } from "@atlaskit/tokens";

const footerStyles = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    boxSizing: "border-box"
});

const contentStyles = css({
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: "4px",
    padding: `8px 0px`
});

const linkStyles = css({
    textDecoration: "none",
    cursor: "pointer"
});

const iconStyles = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: token("color.icon.subtle")
});

const textStyles = css({
    fontFamily: token("font.family.body"),
    fontWeight: token("font.weight.regular"),
    fontSize: "12px",
    lineHeight: "16px",
    color: token("color.text.subtlest"),
    fontFeatureSettings: "'liga' off, 'calt' off",
    fontStyle: "normal",
    margin: 0,
    padding: 0
});
type AIFooterProps = {
    /**
     * URL for the "Verify results" link
     */
    href?: string;
};

export const AIFooter: React.FC<AIFooterProps> = ({
    href = "https://www.atlassian.com/trust/atlassian-intelligence"
}) => {
    return (
        <div css={footerStyles}>
            <div css={contentStyles}>
                <div css={iconStyles}>
                    <InformationCircleIcon label="Information" size="small" />
                </div>
                <a
                    css={linkStyles}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <span css={textStyles}>
                        <FormattedMessage
                            id="RovoChat.usesAI"
                            defaultMessage="Uses AI. Verify results."
                        />
                    </span>
                </a>
            </div>
        </div>
    );
};
